import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import VModal from 'vue-js-modal';
import GetTextPlugin from 'vue-gettext';
import Fragment from 'vue-fragment';
import VueMatchHeights from 'vue-match-heights';
import translations from '../translations.json';
import availableLanguages from './availableLanguages';
import PortalVue from 'portal-vue';

import { dict } from './customErrors';

Vue.use(VueMatchHeights);

Vue.use(PortalVue);

Vue.use(GetTextPlugin, {
    availableLanguages,
    defaultLanguage: 'en_GB',
    translations: translations
});
Vue.use(VeeValidate, {
    events: '',
    classes: true,
    inject: false,
    classNames: {
        invalid: 'is-invalid'
    }
});
Validator.localize('en', dict);
Vue.use(VModal);
Vue.use(Fragment.Plugin);



// WEBPACK FOOTER //
// ./resources/assets/js/setup/plugins.js